"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSendTextBox = exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TypeFocusSink = require("../Utils/TypeFocusSink");

var _Localize = require("../Localization/Localize");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  '& > div, input': {
    flex: 1
  }
});

var connectSendTextBox = function connectSendTextBox() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref) {
    var disabled = _ref.disabled,
        focusSendBox = _ref.focusSendBox,
        language = _ref.language,
        scrollToEnd = _ref.scrollToEnd,
        sendBoxValue = _ref.sendBoxValue,
        setSendBox = _ref.setSendBox,
        stopDictate = _ref.stopDictate,
        submitSendBox = _ref.submitSendBox;
    return {
      disabled: disabled,
      language: language,
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        setSendBox(value);
        stopDictate();
      },
      onKeyPress: function onKeyPress(event) {
        var key = event.key,
            shiftKey = event.shiftKey;

        if (key === 'Enter' && !shiftKey) {
          event.preventDefault();

          if (sendBoxValue) {
            setSendBox(sendBoxValue.trim());
            scrollToEnd();
            submitSendBox();
            focusSendBox();
          }
        }
      },
      onSubmit: function onSubmit(event) {
        event.preventDefault(); // Consider clearing the send box only after we received POST_ACTIVITY_PENDING
        // E.g. if the connection is bad, sending the message essentially do nothing but just clearing the send box

        if (sendBoxValue) {
          scrollToEnd();
          submitSendBox();
        }
      },
      value: sendBoxValue
    };
  }].concat(selectors));
};

exports.connectSendTextBox = connectSendTextBox;

var TextBox = function TextBox(_ref3) {
  var className = _ref3.className,
      disabled = _ref3.disabled,
      language = _ref3.language,
      onChange = _ref3.onChange,
      onKeyPress = _ref3.onKeyPress,
      onSubmit = _ref3.onSubmit,
      styleSet = _ref3.styleSet,
      value = _ref3.value;
  var typeYourMessageString = (0, _Localize.localize)('Type your message', language);
  var sendBoxTextWrap = styleSet.options.sendBoxTextWrap;
  return _react.default.createElement("form", {
    className: (0, _classnames.default)(ROOT_CSS + '', styleSet.sendBoxTextArea + '', styleSet.sendBoxTextBox + '', className + ''),
    onSubmit: onSubmit
  }, _react.default.createElement(_TypeFocusSink.Context.Consumer, null, function (_ref4) {
    var sendFocusRef = _ref4.sendFocusRef;
    return !sendBoxTextWrap ? _react.default.createElement("input", {
      "aria-label": typeYourMessageString,
      "data-id": "webchat-sendbox-input",
      disabled: disabled,
      onChange: onChange,
      placeholder: typeYourMessageString,
      ref: sendFocusRef,
      type: "text",
      value: value
    }) : _react.default.createElement("div", null, _react.default.createElement("textarea", {
      "aria-label": typeYourMessageString,
      "data-id": "webchat-sendbox-input",
      disabled: disabled,
      onChange: onChange,
      onKeyPress: onKeyPress,
      placeholder: typeYourMessageString,
      ref: sendFocusRef,
      rows: "1",
      value: value
    }), _react.default.createElement("div", null, value + '\n'));
  }));
};

TextBox.defaultProps = {
  className: '',
  disabled: false,
  value: ''
};
TextBox.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  language: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onKeyPress: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  styleSet: _propTypes.default.shape({
    options: _propTypes.default.shape({
      sendBoxTextWrap: _propTypes.default.bool.isRequired
    }).isRequired
  }).isRequired,
  value: _propTypes.default.string
};

var _default = connectSendTextBox(function (_ref5) {
  var styleSet = _ref5.styleSet;
  return {
    styleSet: styleSet
  };
})(TextBox);

exports.default = _default;